import AdminCMSList from "@/pages/admin/AdminCMSList";

const STATUS = [
  { value: "idea", label: "Idea Stage" },
  { value: "research", label: "Research Stage" },
  { value: "testing", label: "Testing Stage" },
  { value: "voting", label: "Customer Voting" },
  { value: "launching", label: "Launching Soon" },
  { value: "released", label: "Released" },
];

export default function AdminLabFlavours() {
  return (
    <AdminCMSList
      testIdPrefix="admin-lab" title="Lab Flavour" subtitle="Flavour Laboratory"
      listEndpoint="/admin/lab-flavours"
      createEndpoint="/admin/lab-flavours"
      updateEndpoint={(id) => `/admin/lab-flavours/${id}`}
      deleteEndpoint={(id) => `/admin/lab-flavours/${id}`}
      blank={{ name: "", description: "", image_url: "", status: "idea", voting_enabled: false, is_visible: true, sort_order: 0 }}
      fields={[
        { key: "name", label: "Name", full: true },
        { key: "status", label: "Status", type: "select", options: STATUS },
        { key: "sort_order", label: "Sort order", type: "number" },
        { key: "description", label: "Description", type: "textarea", full: true, rows: 3 },
        { key: "image_url", label: "Image URL", full: true },
        { key: "voting_enabled", label: "Customer voting", type: "checkbox", help: "Allow public votes" },
        { key: "is_visible", label: "Visible on site", type: "checkbox", help: "Show on /flavour-lab" },
      ]}
      renderCard={(f) => (
        <div className="p-5">
          {f.image_url && <img src={f.image_url} alt={f.name} className="aspect-video w-full object-cover rounded-xl mb-3" />}
          <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{f.status}</div>
          <div className="font-display text-xl mt-1">{f.name}</div>
          <p className="text-xs text-brand-charcoal/70 mt-2 line-clamp-2">{f.description}</p>
          {f.voting_enabled && <div className="mt-2 text-[10px] text-brand-charcoal/60">Votes: ❤️ {f.votes?.love||0} · 🔥 {f.votes?.must_try||0} · 🚀 {f.votes?.make_now||0}</div>}
        </div>
      )}
    />
  );
}
